import { Marker } from 'react-mapbox-gl';
import React from 'react';
import PropTypes from 'prop-types';
import { CoordinatesExact } from '../../models/Coordinates';
import { Icon } from '../../../common/components/icons';
import useStyles from './Obstacle.styles';
import { sizeEnum } from '../../../common/components/icons/Icon';

const Obstacle = ({ coordinate, visible }) => {
  const classes = useStyles();

  if (!visible) return null;

  return (
    <Marker coordinates={[coordinate.longitude, coordinate.latitude]} anchor="center">
      <Icon icon="report_gmailerrorred" className={classes.icon} size={sizeEnum.small} />
    </Marker>
  );
};

Obstacle.propTypes = {
  coordinate: CoordinatesExact.isRequired,
  visible: PropTypes.bool,
};

Obstacle.defaultProps = {
  visible: true,
};

export default React.memo(Obstacle);
